import { ApiBase, InternationalizedField } from '@/api/common';
import { bus } from '@/bus';
import config from '@/config';
import { BusEvent } from '@/models/bus';
import store, { Mutation } from '@/store';
import { safeLock } from '@/util/common/util';
import { isNil } from 'lodash';
import ApiList from './list';
import Module from './module';

export default class Program extends ApiBase<Module> {
  public static readonly SLUG: string = 'program';
  public readonly SLUG: string = 'program';
  public static readonly API_SLUG: string = 'program';
  private static readonly URL_BASE: string = config.API_ROOT + '/program/';

  public name: InternationalizedField<string> = new InternationalizedField<string>();
  public school: number;
  public order?: number = undefined;
  public program_skill_1: number = null;
  public program_skill_2: number = null;
  public mini_assessment_id: string = '';
  public program_order: number = null;
  public is_program: boolean = true;
  public bg_image?: number | null = undefined;
  public bg_image_link?: string | null = undefined;
  public parent_project?: any = undefined;
  public theme?: number = undefined;

  public constructor() {
    super({
      urlBase: Program.URL_BASE
    });
  }

  public assign(response: any): Program {
    super.assign(response);
    if (isNil(response)) {
      return this;
    }

    if ('name' in response) {
      this.name = new InternationalizedField<string>(response.name);
    }

    if (isNil(response)) {
      return this;
    }

    if ('name' in response) {
      this.name = new InternationalizedField<string>(response.name);
    }

    return this;
  }

  public static async get(id: number): Promise<Program> {
    return this.doGet({
      urlBase: Program.URL_BASE,
      id,
      create: (response) => new Program().assign(response)
    });
  }

  public getName(): string {
    const name = this.name.getDefaultValue();
    if (name) {
      return name;
    }
    return '';
  }

  public static async listAll() {
    return this.doList({
      urlBase: Program.URL_BASE,
      create: (response) => new Program().assign(response),
      all: true,
      parameters: {
        minimal: true
      },
      readFromCache: () => store.state.programList,
      writeToCache: async (list: ApiList<Program>) =>
        store.commit(Mutation.CACHE_PROGRAM_LIST, list)
    });
  }

  public async save(): Promise<number> {
    const isNew = isNil(this.id);
    this.theme = this.program_skill_1;

    const id = await super.save();
    store.commit(
      isNew ? Mutation.ADD_TO_PROGRAM_LIST : Mutation.PROGRAM_UPDATED,
      this
    );
    bus.$emit(BusEvent.CACHE_CHANGED);
    return id;
  }

  public async update(): Promise<number> {
    if (isNil(this.id)) {
      return this.save();
    } else {
      this.theme = this.program_skill_1;

      return safeLock(Module.SLUG, this.id, async () => {
        const id = await super.save();
        store.commit(Mutation.PROGRAM_UPDATED, this);
        bus.$emit(BusEvent.CACHE_CHANGED);
        return id;
      });
    }
  }
}
